import { Component, OnInit, ElementRef } from '@angular/core';
import { ROUTES } from '../sidebar/sidebar.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
import { UserService } from '../../services/api/user.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  public focus;
  public listTitles: any[];
  public location: Location;
  userFullname: any
  skeletonLoading: boolean = true

  constructor(location: Location, 
     private element: ElementRef, 
     private router: Router,
     private usersrvc: UserService) {
    this.location = location;
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    if(localStorage.getItem('USER_INFO')){
      let userData = JSON.parse(localStorage.getItem('USER_INFO'))
      // console.log("userData", userData);
      this.userFullname = userData.firstName + " " + userData.lastName
    }else{
      this.getUser()
    }
  }

  getTitle(){
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if(titlee.charAt(0) === '#'){
        titlee = titlee.slice( 1 );
    }

    for(var item = 0; item < this.listTitles.length; item++){
        if(this.listTitles[item].path === titlee){
            return this.listTitles[item].title;
        }
    }
    return 'Dashboard';
  }

  getUser(){
    let token = localStorage.getItem('authToken')
    this.usersrvc.getUserInfo(token)
    .then(async response => {
      if(response["success"]){
        let userData = response["data"].user
        // // console.log("userData", userData);
        
        this.userFullname = await userData.firstName + " " + userData.lastName
        // console.log("userData", this.userFullname);

        let initUserData = {
          accountId: userData.accountId,
          firstName: userData.firstName,
          lastName: userData.lastName,
          contactNumber: userData.contactNumber,
          email: userData.email,
          groupId: userData.groupId,
          isActive: userData.isActive,
          type: userData.type,
          username: userData.username,
          validationStatus: userData.validationStatus
        }


        localStorage.setItem('USER_INFO', JSON.stringify(initUserData))
      }
    })
  }

  decodeToken(token: string) {
    try {
      return jwt_decode(token);
    } catch (err) {
      return null;
    }
  }

  

}
